import  Vue from 'vue'

let courseType = '';
// courseType = '_type3'

export default {
    namespaced: true,
    state: {
        courses: {
            items: [],
            _meta: {
                currentPage: 0,
                pageCount: 0,
                perPage: 15,
                totalCount: 0
            }
        },
        comments: {
            items: [],
            _meta: {
                currentPage: 0,
                pageCount: 0,
                perPage: 15,
                totalCount: 0
            }
        },
        course: {},
        stream_id: [],
        streams: [],
        streamsEntries: [],
        streamsMy: [],
        myLessonsState:[],
        applications: [],
        history: {
            waiting: [],
            confirmed: [],
            end: []
        },
        reviews: {
            items: [],
            _meta: {
                currentPage: 0,
                pageCount: 0,
                perPage: 15,
                totalCount: 0
            }
        },
        entries: {
            active: {
                items: [],
                _meta: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 15,
                    totalCount: 0
                }
            },
            past: {
                items: [],
                _meta: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 15,
                    totalCount: 0
                }
            }
        },
        myCourses: {
            active: {
                items: [],
                _meta: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 15,
                    totalCount: 0
                }
            },
            unpublished: {
                items: [],
                _meta: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 15,
                    totalCount: 0
                }
            }
        },
        visited: {
            items: [],
            _meta: {
                currentPage: 0,
                pageCount: 0,
                perPage: 15,
                totalCount: 0
            }
        },
        reviewId: null
    },
    getters: {
        courses(state){
            return state.courses;
        },
        comments(state){
            return state.comments;
        },
        course(state){
            return state.course;
        },
        stream_id(state){
            return state.stream_id;
        },
        streams(state){
            return state.streams;
        },
        myLessonsState(state) {
            return state.myLessonsState;
        },
        streamsEntries(state){
            return state.streamsEntries;
        },
        streamsMy(state){
            return state.streamsMy;
        },
        applications(state){
            return state.applications;
        },
        history(state){
            return state.history;
        },
        reviews(state){
            return state.reviews;
        },
        entries(state){
            return state.entries;
        },
        myCourses(state){
            return state.myCourses;
        },
        visited(state){
            return state.visited.items;
        },
        reviewId(state){
            return state.reviewId;
        }
    },
    mutations: {
        SetCourses(state, data){
            state.courses = data;
        },
        SetComments(state, data){
            state.comments = data;
        },
        SetCourse(state, data){
            state.course = data;
        },
        SetStreams(state, data){
            state.streams = data;
        },
        SetStreamsEntries(state, data){
            state.streamsEntries = data;
        },
        setStreamId(state, data){
            state.stream_id = data;
        },
        SetStreamsMy(state, data){
            state.streamsMy = data;
        },
        SetMyLessonsState(state, data) {
            state.myLessonsState = data;
        },
        SetApplications(state, data){
            state.applications = data;
        },
        SetHistory(state, data){
            state.history = data;
        },
        SetReviews(state, data){
            state.reviews = data;
        },
        SetEntries(state, data){
            state.entries.active = data;
        },
        SetEntriesPast(state, data){
            state.entries.past = data;
        },
        SetMyCourses(state, data){
            state.myCourses.active = data;
        },
        SetMyCoursesUnpublished(state, data){
            state.myCourses.unpublished = data;
        },
        setVisited(state, data){
            state.visited = data
        },
        SetReviewId(state, data){
            state.reviewId = data
        }
    },
    actions: {
        LoadCourses ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/courseList.json' : 'courses';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetCourses' ,data);
                        resolve();
                    })
            })
        },
        LoadCoursesPopular ({commit}){
            let url = process.env.NODE_ENV !== 'production' ? 'course/courseListPopular.json' : 'coursesPopular';

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetCourses' ,data);
                        resolve();
                    })
            })
        },
        LoadCourse ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/courseInfo_my'+courseType+'.json' : 'courses/' + data.id;

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetCourse' ,data);
                        resolve(true);
                    }).catch(() => {
                        resolve(false);
                    })
            })
        },
        LoadComments ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/comments.json' : 'courses/' + data.id + '/comments';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: {page: data.page}})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetComments' ,data);
                        resolve(true);
                    }).catch(() => {
                    resolve(false);
                })
            })
        },
        setStreamId({commit}, data){
            commit('setStreamId' ,data);
        },
        LoadStreams ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/streams_my'+courseType+'.json' : 'courses/' + data.id + '/streams';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: {start: data.start, end: data.end}})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetStreams' ,data);
                        resolve(data);
                    })
            })
        },
        LoadStreamsEntries ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/streamsEntries.json' : 'entries/streams';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetStreamsEntries' ,data);
                        resolve();
                    })
            })
        },
        LoadStreamsMy ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/streamsMy.json' : 'myCourses/streams';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetStreamsMy' ,data);
                        resolve();
                    })
            })
        },
        LoadMyLessonsState ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/lessonsState.json' : 'myCourses/lessonsState';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetMyLessonsState' ,data);
                        resolve();
                    })
            })
        },
        LoadApplications ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/applications.json' : 'courses/' + data.id + '/applications';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: {date: data.date}})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetApplications' ,data);
                        resolve();
                    })
            })
        },
        LoadHistory ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/history.json' : 'course/' + data.id + '/history';

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetHistory' ,data);
                        resolve(true);
                    }).catch(data => {
                        resolve(true);
                    })
            })
        },
        LoadReviews ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/reviews.json' : 'course/' + data.id + '/reviews';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: {page: data.page}})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetReviews' ,data);
                        resolve(true);
                    })
            })
        },
        LoadEntries ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/entries.json' : 'entries';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetEntries' ,data);
                        resolve();
                    })
            })
        },
        LoadEntriesPast ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/entriesPast.json' : 'entries';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: Object.assign(data, {type: 'past'})})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetEntriesPast' ,data);
                        resolve();
                    })
            })
        },
        LoadMyCourses ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/myCourses.json' : 'myCourses';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetMyCourses' ,data);
                        resolve();
                    })
            })
        },
        LoadMyCoursesUnpublished ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'course/myCoursesUnpublished.json' : 'myCourses';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: Object.assign(data, {type: 'unpublished'})})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetMyCoursesUnpublished' ,data);
                        resolve();
                    })
            })
        },
        LoadMyVisited ({ commit }, data) {
            let url = process.env.NODE_ENV !== 'production' ? 'course/visited.json' : 'visited';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('setVisited' ,data);
                        resolve();
                    })
            })
        },
        SetReviewId({commit}, data){
            commit('SetReviewId' ,data);
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/coursesList.js